import React, { useEffect, useState } from 'react';

import { getData,postData, putData } from '../../../../global/Globalapi';
import EditFormDetails from './EditFormDetails';
import NewVariant from './NewVariant';
import Step3 from "../../../DynamicComp/Step3"
import Inputfield from "../../../DynamicComp/Inputfield";

const Editproductmaster = ({
  formData,
  setFormData,
  editId,
  childImages,
  setEditId,
  handleImagesUpdate,
  mastereditid
}) => {
  const  [variantDetails, setvariantDetails] = useState([]);
  const [selectedVariantId, setSelectedVariantId] = useState(null);
 const [addvariant,setaddvariant]=useState(false);

 const[selectedvalues,setSelectedvalues]=useState([]);
 const[newproductid,setNewProductId]=useState();
 const[combos,setCombos]=useState([]);
 const [hasVariant, setHasVariant] = useState(true);
 const[Features,setFeatures]=useState([]);
 const [variantAttrsWithOpts, setVariantAttrsWithOpts] = useState([]);
const [showDeliveryOptions, setShowDeliveryOptions] = useState(false);
 const [deliveryOptions, setDeliveryOptions] = useState({
  home_delivery: 0,
  home_delivery_amount: "",
  take_away: 0,
  take_away_amount: "",
  safe_delivery: 0,
  safe_delivery_amount: "",
});

useEffect(() => {
  if (!selectedVariantId && !mastereditid) return;

  const id = selectedVariantId || mastereditid;

  getData(`/product_delivery/${id}`)
    .then((res) => {
      if (res?.data) {
        setDeliveryOptions({
          home_delivery: res.data.home_delivery ?? 0,
          home_delivery_amount: res.data.home_delivery_amount ?? "",
          take_away: res.data.take_away ?? 0,
          take_away_amount: res.data.take_away_amount ?? "",
          safe_delivery: res.data.safe_delivery ?? 0,
          safe_delivery_amount: res.data.safe_delivery_amount ?? "",
        });
      }
    })
    .catch((err) => {
      console.error("Delivery fetch error", err);
    });
}, [selectedVariantId, mastereditid]);

 useEffect(() => {
  if (Features && Features.length > 0) {
    console.log('Updated Features:', Features);
  }
   fetchOptions();
}, [Features]);

useEffect(()=>{
  fetchFeatures(formData.groupName);
  
},[formData.groupId])


const fetchFeatures = async (groupId) => {
  if (!groupId) {
    setFeatures([]);
    return;
  }
  try {
    // setError(null);
    const res = await getData(`/getComponentMap/${groupId}`);
    console.log("api data")
    console.log(res)
    setFeatures(res.data);
    
  } catch (err) {
    // setError(err.message || 'Error fetching features');
  }
};



 const fetchOptions = async () => {

  const variantAttributes = Features.filter(
    (f) => f.Attribute_Category === "Variant_Deterministic"
  );


    const variantPromises = variantAttributes.map(async (feature) => {
      const id=feature.id
      const res = await getData(`/productoption/${id}`);
      console.log('productoptions22',res.data);
      return { feature, options: res.data };
    });

    const variantResults = await Promise.all(variantPromises);

    setVariantAttrsWithOpts(
      variantResults.map(({ feature, options }) => ({
        ...feature,
        options,
      }))
    );


 }
  
const fetchvariants=async()=>{
  try{
   const res=await getData(`/variant_product_details/${mastereditid}`);
   if(res){
    setvariantDetails(res.data);
   }
  }
  catch(err){
    console.log("Error fetching variants",err)
  }
}

const handleVariantSaveComplete = () => {
  console.log("Variants saved successfully!");
};

const handleaddvariant=()=>{
  setSelectedVariantId(null);
  setaddvariant(true)
}
useEffect(() => {
 fetchvariants();
}, [mastereditid])
useEffect(() => {
 
  setEditId(selectedVariantId);
 

}, [selectedVariantId])
return(
  <div>
   {addvariant ? (
    <div>
      <div>
            <button
            className="float-right bottom-4 right-4 bg-red-400 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors"
              onClick={(e) => {
          e.stopPropagation();
          setaddvariant(false);
        }}
        > back</button>
      </div>
      <div>

        <div className="bg-white p-4 rounded-lg border border-gray-300 shadow-md">
            {variantAttrsWithOpts.length > 0 ? (
                <div className="space-y-6">
                    {variantAttrsWithOpts.map((feature) => (
                        <Inputfield key={feature.attribute_id} type={feature.Attribute_Type} label={feature.attribute_name} name={feature.attribute_id} options={feature.options?.map(opt => opt.option) || []} selectedValues={selectedvalues} setSelectedValues={setSelectedvalues} required={true} Attribute_Category={feature.Attribute_Category} ID={feature.id} Parent_Variant_Id={feature.Parent_Variant_Id} Attribute_Type={feature.Attribute_Type}ide={feature.id} />
                    ))}
                </div>
            ) : (
                <p className="text-gray-500">No Variant attributes available.</p>
            )}
        </div>


        <Step3
                selectedvalues={selectedvalues}
                combos={combos}
                setCombos={setCombos}
                Features={Features}
                newproductid={newproductid}  // This now passes the correct, current state value
                onSaveComplete={handleVariantSaveComplete}
                hasVariant={hasVariant}
            />
        {/* <NewVariant/> */}
      </div>
    </div>
   ):(
    


     <div> 

    <div>
   
<button
  className="float-right bg-blue-400 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
  onClick={() => setShowDeliveryOptions(!showDeliveryOptions)}
>
  Delivery Options
</button>
    <button
        className="float-right bg-red-400 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors mr-3"
          onClick={(e) => {
      e.stopPropagation();
      handleaddvariant();
    }}
      >
      Add Variant
    </button>
    <br />
    </div>
    <h1>Product Details</h1>
    {/* <div className="mt-4 border-t pt-4"> */}
  {/* <h3 className="font-semibold mb-2">Delivery Options</h3> */}

  {/* Home Delivery */}
  {/* <div className="flex items-center gap-3 mb-2">
    <input
      type="checkbox"
      checked={deliveryOptions.home_delivery === 1}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          home_delivery: e.target.checked ? 1 : 0,
        })
      }
    />
    <span>Home Delivery</span>
    <input
      type="number"
      placeholder="Amount"
      className="border p-1 rounded w-24"
      value={deliveryOptions.home_delivery_amount}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          home_delivery_amount: e.target.value,
        })
      }
    />
  </div> */}

  {/* Take Away */}
  {/* <div className="flex items-center gap-3 mb-2">
    <input
      type="checkbox"
      checked={deliveryOptions.take_away === 1}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          take_away: e.target.checked ? 1 : 0,
        })
      }
    />
    <span>Take Away</span>
    <input
      type="number"
      placeholder="Amount"
      className="border p-1 rounded w-24"
      value={deliveryOptions.take_away_amount}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          take_away_amount: e.target.value,
        })
      }
    />
  </div> */}

  {/* Safe Delivery */}
  {/* <div className="flex items-center gap-3">
    <input
      type="checkbox"
      checked={deliveryOptions.safe_delivery === 1}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          safe_delivery: e.target.checked ? 1 : 0,
        })
      }
    />
    <span>Safe Delivery</span>
    <input
      type="number"
      placeholder="Amount"
      className="border p-1 rounded w-24"
      value={deliveryOptions.safe_delivery_amount}
      onChange={(e) =>
        setDeliveryOptions({
          ...deliveryOptions,
          safe_delivery_amount: e.target.value,
        })
      }
    />
  </div> */}
{/* </div> */}
{showDeliveryOptions && (
  <div className="mt-6 flex justify-center">
    <div className="bg-white border border-gray-200 rounded-2xl shadow-md p-5 w-full max-w-xl">

      <h3 className="text-lg font-semibold mb-4 border-b pb-2 text-center">
        Delivery Options
      </h3>

      {/* Home Delivery */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={deliveryOptions.home_delivery === 1}
            onChange={(e) =>
              setDeliveryOptions({
                ...deliveryOptions,
                home_delivery: e.target.checked ? 1 : 0,
              })
            }
          />
          <span className="font-medium">Home Delivery</span>
        </div>

        <input
          type="number"
          placeholder="Amount"
          className="border border-gray-300 p-1 rounded w-28"
          value={deliveryOptions.home_delivery_amount}
          onChange={(e) =>
            setDeliveryOptions({
              ...deliveryOptions,
              home_delivery_amount: e.target.value,
            })
          }
        />
      </div>

      {/* Take Away */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={deliveryOptions.take_away === 1}
            onChange={(e) =>
              setDeliveryOptions({
                ...deliveryOptions,
                take_away: e.target.checked ? 1 : 0,
              })
            }
          />
          <span className="font-medium">Take Away</span>
        </div>

        <input
          type="number"
          placeholder="Amount"
          className="border border-gray-300 p-1 rounded w-28"
          value={deliveryOptions.take_away_amount}
          onChange={(e) =>
            setDeliveryOptions({
              ...deliveryOptions,
              take_away_amount: e.target.value,
            })
          }
        />
      </div>

      {/* Safe Delivery */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={deliveryOptions.safe_delivery === 1}
            onChange={(e) =>
              setDeliveryOptions({
                ...deliveryOptions,
                safe_delivery: e.target.checked ? 1 : 0,
              })
            }
          />
          <span className="font-medium">Safe Delivery</span>
        </div>

        <input
          type="number"
          placeholder="Amount"
          className="border border-gray-300 p-1 rounded w-28"
          value={deliveryOptions.safe_delivery_amount}
          onChange={(e) =>
            setDeliveryOptions({
              ...deliveryOptions,
              safe_delivery_amount: e.target.value,
            })
          }
        />
      </div>

      <div className="flex justify-end">
        <button
          className="px-6 py-2 bg-green-600 text-white font-semibold rounded-lg shadow hover:bg-green-700"
          onClick={async () => {
            const id = selectedVariantId || mastereditid;

            await putData(`/product_delivery/${id}`, deliveryOptions);
            alert("Delivery options saved successfully ✅");
          }}
        >
          Save Delivery Options
        </button>
      </div>

    </div>
  </div>
)}
   <div
  className="w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-3 cursor-pointer hover:shadow-lg hover:border-indigo-400 transition-all duration-300 mb-4 relative"
  onClick={() => setSelectedVariantId(mastereditid)}
>
  <p>SKU: {mastereditid} Main Product</p>


  {selectedVariantId === mastereditid && (
    <div className="mt-2 max-h-64 overflow-y-auto border-t border-gray-200 pt-2">
      <EditFormDetails
        setFormData={setFormData}
        formData={formData}
        childImages={childImages}
        editId={mastereditid}
        handleImagesUpdate={handleImagesUpdate}
      />
    </div>
  )}
      
</div>
    <div>
      {variantDetails && variantDetails.length >0 ?(
        variantDetails.map((variant)=>(
                  <div
    key={variant.product_id}
    className="w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-3 cursor-pointer hover:shadow-lg hover:border-indigo-400 transition-all duration-300 mb-4 relative"
    onClick={() => setSelectedVariantId(variant.product_id)}
  >
    <h3 className="font-semibold text-lg">{variant.product_name}</h3>
    <p>SKU: {variant.product_id}, Price: ₹{variant.unit_selling_price}, Combo:{variant.Combo}</p>

    {selectedVariantId === variant.product_id && (
      <div className="mt-2 max-h-64 overflow-y-auto border-t border-gray-200 pt-2">
        <EditFormDetails
          setFormData={setFormData}
          formData={formData}
          childImages={childImages}
          editId={variant.product_id}
          handleImagesUpdate={handleImagesUpdate}
        />
      </div>
    )}
  </div>
        ))
      ):
      (
        <div>
          <h2 className="text-xl font-semibold mb-4"> No Variants to Display</h2>
        </div>
      )}
    </div>

  </div>
   )}

  </div>
 

)
};

export default Editproductmaster;
